import { initialState } from "./state"

export default {
  setState: (state, payload) => (state.state = payload),
  setPos: (state, payload) => (state.pos = payload),
  setSeller: (state, payload) => (state.seller = payload),
  setCaption: (state, payload) => (state.caption = payload),
  setWallet: (state, payload) => (state.wallet = payload),
  setStateOptions: (state, payload) => (state.stateOptions = payload),
  setPosOptions: (state, payload) => (state.posOptions = payload),
  setSellerOptions: (state, payload) => (state.sellerOptions = payload),
  setCaptationOptions: (state, payload) => (state.captationOptions = payload),
  resetPos: state => {
    const INITIAL_STATE = initialState()
    Object.keys(state).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  }
}
